const footerLinks = [
  { id: "entries", label: "入口速查" },
  { id: "troubleshoot", label: "打不开排查" },
  { id: "trust", label: "可信说明" },
  { id: "collect", label: "收藏指南" },
  { id: "faq", label: "常见问答" },
];

export default function SiteFooter() {
  return (
    <>
      <section className="w-full px-4 md:px-8 py-12 md:py-14 bg-background-50">
        <div className="max-w-6xl mx-auto relative rounded-lg overflow-hidden border border-background-200">
          <img
            src="https://readdy.ai/api/search-image?query=minimal%20warm%20abstract%20flowing%20ribbon%20lines%20on%20soft%20cream%20background%20with%20amber%20green%20gradient%20accents%2C%20clean%20flat%20illustration%2C%20calm%20modern%20editorial%20banner&width=1400&height=560&seq=91cta-band&orientation=landscape"
            alt="收藏入口提示背景"
            title="91网入口收藏提示"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-background-50/85"></div>
          <div className="relative z-10 px-5 md:px-10 py-12 md:py-16 text-center">
            <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-950">
              收藏本页，入口变动不再迷路
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 max-w-2xl mx-auto">
              把本页加入书签，就是给自己留一个固定的入口。地址有更新，回到这里就能看到最新可用线路。
            </p>
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="#top"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-arrow-up-line"></i>
                回到顶部速查
              </a>
              <a
                href="#entries"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300 bg-background-50/80 text-foreground-900 text-sm font-medium hover:border-primary-300 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-list-check-2"></i>
                查看入口列表
              </a>
            </div>
          </div>
        </div>
      </section>

      <footer className="w-full px-4 md:px-8 pt-12 pb-8 bg-secondary-100 border-t border-secondary-200">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <div className="flex items-center gap-2">
                <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-heading font-bold text-lg">
                  91
                </span>
                <span className="font-heading font-bold text-lg text-foreground-950">91网</span>
              </div>
              <p className="mt-4 text-xs leading-relaxed text-foreground-600 max-w-xs">
                面向查找入口与最新地址的访问者，提供集中、可核对的可用线路汇总。本站仅作入口指引，不涉及注册、登录或任何表单填写。
              </p>
            </div>

            <div>
              <h4 className="font-medium text-sm text-foreground-950">页面导航</h4>
              <ul className="mt-4 flex flex-wrap gap-x-6 gap-y-2">
                {footerLinks.map((link) => (
                  <li key={link.id}>
                    <a
                      href={`#${link.id}`}
                      className="text-xs text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-medium text-sm text-foreground-950">温馨提示</h4>
              <ul className="mt-4 flex flex-col gap-2">
                <li className="flex items-start gap-2 text-xs text-foreground-600">
                  <i className="ri-checkbox-circle-line text-accent-600 mt-0.5"></i>
                  入口状态会不定期更新，请以本页显示为准。
                </li>
                <li className="flex items-start gap-2 text-xs text-foreground-600">
                  <i className="ri-checkbox-circle-line text-accent-600 mt-0.5"></i>
                  遇到仿冒页面请勿输入任何个人信息。
                </li>
                <li className="flex items-start gap-2 text-xs text-foreground-600">
                  <i className="ri-checkbox-circle-line text-accent-600 mt-0.5"></i>
                  建议收藏本页作为长期固定入口。
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              © 2026 91网入口汇总页 · 仅作地址与入口指引
            </p>
            <p className="text-xs text-foreground-500">页面内容以实际可访问状态为准</p>
          </div>
        </div>
      </footer>
    </>
  );
}